import React, { useContext, useEffect, useState } from 'react';
import "../Styles/TATTimelineCss.css";
import { useTranslation } from 'react-i18next';
import { Eye24Regular, CloudCheckmark24Regular, CloudDismiss24Regular, InfoRegular, Info24Regular, Info20Regular } from "@fluentui/react-icons";
import Download from '../../../../components/SVGComponents/Download';
import CheckCircle from '../../../../components/SVGComponents/CheckCircle';
import TimeQuery from '../../../../components/SVGComponents/TimeQuery';
import RowBadge from '../Badge/RowBadge';
import Moment from "moment";
import themeContext from '../../../../context/theme/ThemeContext';
import { USERTYPES } from '../../../../constants/Constants';
import userContext from '../../../../context/users/UserContext';
import SeriesUploadHistory from '../SeriesUploadHistory';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import ModalHeader from '../../../../components/Modal/ModalHeader';
import ModalMain from '../../../../components/Modal/ModalMain';
import { Icon } from '@fluentui/react';
import CustomToolTipHost from '../../../../components/CustomToolTipHost/CustomToolTipHost';
import { normalizeTimeZone } from '../../../IssuesAndTroubleshooting/helper/helper';
import moment from "moment-timezone";
import { getEnv } from '../../../../helpers/EnvHelper';

const TATTimelineBody = (props) => {
    const [t] = useTranslation();
    const { getThemeColor,getAlterColor, themeName } = useContext(themeContext);
    const studyData = props.studyCloseData;
    const [showEstimatedTimeEnabled, setShowEstimatedTimeEnabled] = useState(true);
    const { roles} = useContext(userContext);
    const [showSeriesUploadHistory, setShowSeriesUploadHistory] = useState(false);

    const getClosedStatus = () => {
      if(studyData?.closed != null && studyData?.closed != undefined && studyData?.closed){
        return true;
      }
      return false;
    }

    useEffect(() =>{
      if(getEnv("REACT_APP_VDC_PLATFORM") === "true" && roles[0] == USERTYPES.RADIOLOGIST){
        setShowEstimatedTimeEnabled(false);
      }
    }, [])

    const getActiveClassName = (data,index) => {
      //(idx == 0 ? data.active? 'active-timeline-line-first':'timeline-line-first' ? 'active-timeline-line' : 'timeline-line':''
      if(index == 0){
        if(data.active){
          return 'active-timeline-line-first';
        }else{
          return getClosedStatus()?'timeline-line-first closed-timeline-line':'timeline-line-first';
        }
      }else if(index == props.timelineStatus?.length-1){
        if(data.active){
          return 'active-timeline-line-last';
        }else{
          return getClosedStatus()?'timeline-line-last closed-timeline-line':'timeline-line-last';
        }
      }else{
        if(data.active){
          return 'active-timeline-line';
        }else{
          return getClosedStatus()?'timeline-line closed-timeline-line':'timeline-line';
        }
      }
    }

    const getOtherTimelineActiveClassName = (data,index) => {
      //(idx == 0 ? data.active? 'active-timeline-line-first':'timeline-line-first' ? 'active-timeline-line' : 'timeline-line':''
      if(index == 0){
          return 'active-timeline-line-first';
      }else if(index == props.otherTimeline?.length-1){
          return 'active-timeline-line-last';
      }else{
          return 'active-timeline-line';
      }
    }

    const getQcTimelineActionLabel = (actionName) => {
      if (!actionName) return "";
      return actionName
        .replaceAll("QCREVIEW", "QC Review")
        .replaceAll("QCVERIFY", "QC Verify")
        .replaceAll("QCFIXER", "QC Fixer")
        .replaceAll("QCFIX", "QC Fix")
        .replaceAll("_", " ")
        .replaceAll("ACTION", "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
    }

    function formatMinutes(minutes) {
      if (minutes === "NA") return minutes;
      
      let negative = false;
      if (minutes.startsWith("-")) {
        negative = true;
        minutes = minutes.substring(1);
      }
    
      const duration = Moment.duration(minutes, 'minutes');

    // Get the components
    const years = duration.years();
    const months = duration.months();
    const days = duration.days();
    const hours = duration.hours();
    const minutesVar = duration.minutes();
    const seconds = duration.seconds();
    let formattedTime = "";

    // if(seconds > 0){
    //   formattedTime = `${years}Y : ${months}M : ${days}D : ${hours}H : ${minutesVar}M : ${seconds}S`;
    // }else{
    //   formattedTime = `${years}Y : ${months}M : ${days}D : ${hours}H : ${minutesVar}M`;
    // }

    switch(true){
      case years > 0:
        formattedTime = `${years}-Years, ${months}-Months, ${days}-Days, ${hours}-Hours, ${minutesVar}-Minutes`;
        break;
      
      case months > 0:
        formattedTime = `${months}-Months, ${days}-Days, ${hours}-Hours, ${minutesVar}-Minutes`;
        break;

      case days > 0:
        formattedTime = `${days}-Days, ${hours}-Hours, ${minutesVar}-Minutes`;
          break;

      case hours > 0:
        formattedTime = `${hours}-Hours, ${minutesVar}-Minutes`;
        break;

      case minutesVar >= 0:
        formattedTime = `${minutesVar}-Minutes`;
        break;
      
      case seconds > 0:
       

      default:
        break;
    }
    
    if(seconds > 0){
      formattedTime = `,${seconds}-Seconds`
    }
    
      return negative ? "(Delayed) " + formattedTime : formattedTime;
    }


const BACKEND_TZ = getEnv("REACT_APP_BACKEND_TIMEZONE");

const getFormatedDate = (date) => {
  if (!date) return "No Date";

  // OLD: const rawUserTz = localStorage.getItem("userTimeZone");
  const rawUserTz = sessionStorage.getItem("userTimeZone");
  const userTz = normalizeTimeZone(rawUserTz);
  const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Try all possible backend formats
  const momentDate = moment.tz(
    date,
    [
      "YYYY-MM-DD HH:mm:ss",     // 🔥 NEW backend format
      "DD-MMM-YY HH:mm:ss",      // Old format
      "DD-MMM-YY HH:mm:ss.SSS",  // Old with millis
      moment.ISO_8601            // ISO fallback
    ],
    true,
    BACKEND_TZ
  );

  if (!momentDate.isValid()) {
    console.error("Invalid backend date:", date);
    return "No Date";
  }

  const displayTz = userTz || systemTz;

  return momentDate
    .tz(displayTz)
    .format("DD-MMM-YY HH:mm:ss");
};


    

    // const getFormatedDate = (date) => {
    //   var currentDate = Moment(date).local().format("DD-MMM-YY HH:mm:ss");
    //   return currentDate;
    // };

  let PrimaryButtonList = [];
  
  let DefaultButtonList = [
    {
        title: t("button.cancel"),
        onclick: () => setShowSeriesUploadHistory(false),
    },
  ];
  
  let modalDetails = {
      header: (
        <ModalHeader
          updatedModal={true}
          patientName="Mary Frank"
          patientID="123456"
          heading={"Series Upload Timeline"}
          handleCancel={() => setShowSeriesUploadHistory(false)}
        />
      ),
      footer:
        <ModalFooter 
          PrimaryButtonList={PrimaryButtonList}
          DefaultButtonList={DefaultButtonList}
        />,
      body: (
        <SeriesUploadHistory studyId={props.studyId} />
      ),
      width: "500px",
    };


  return (
    <div className="tat-timeline-container" style={{minHeight:"350px",maxHeight:"475px",overflowY:"auto"}}>
      {(showEstimatedTimeEnabled && studyData?.closed != true && props.data.reportDoneStatus != null && props.data.reportDoneStatus != null && props.data.reportDoneStatus != 2) && <div className="estimated-div">
        <p className='estimated-time'>{t("tat-timeline.estimated-time-for-report")}: <span>{props.estimateTime}&nbsp;mins</span></p>
      </div>}
      {
        studyData?.closed == true && <div className="estimated-div">
          <p className='estimated-time' style={{color:"red"}}>{t("tat-timeline.closed-study")}: <span style={{color:"white"}}>{studyData?.closedReason}</span></p>
        </div>
      }
      <div className="estimated-div" style={{display: "flex"}}>
        {(props.timelineData.lastImageUploadDateString != null && props.timelineData.lastImageUploadDateString != undefined && props.timelineData.lastImageUploadDateString != "NA" && props.timelineData.lastImageUploadDateString != "") && <>
            <p className='estimated-time'>{t("tat-timeline.last-image-upload-date")}: <span>{getFormatedDate(props.timelineData.lastImageUploadDateString)}</span></p>
            <CustomToolTipHost content="View Details"><Info20Regular style={{marginLeft:"10px",cursor:"pointer"}} onClick={() => setShowSeriesUploadHistory(true)}/></CustomToolTipHost>
            {props.timelineData.lastImageUploadAfterReport  && <CustomToolTipHost content={`Last image was uploaded ${props.timelineData.lastImageUploadReportDiffString} minutes after the report was submitted.`}><span style={{ color: "red", marginLeft: "10px", fontWeight: 800 }}>!</span></CustomToolTipHost>}
          </>
        }    
      </div>
      
      <div className="timeline-container">
          {props.timelineStatus.map((data, idx) => (
            <div key={idx} className={getActiveClassName(data,idx)}>
              <div className="timeline-item" style={{width:getEnv("REACT_APP_HYBRID_MODE") == "false" ? "48%":"44%"}}>
                {(idx != 0 && data.diff != "NA" && data.diff != "" && data.diff?.length > 0) && <div style={{color:getAlterColor("#C1C1C1","rgb(75 75 75)")}} className='time-difference-container'> 
                <span style={{color: getThemeColor("primary-color")}} className='time-difference-text'>
                {/* <RowBadge tooltipText="Elapsed Time" name="ET" /> */}
                
                {t("label.elapse-time")}:&nbsp;
                </span> {formatMinutes(data.diff)}
                  </div>}
                <div style={{color: getThemeColor("primary-color")}} className="timeline-item-content">                    
                    <p className='timeline-item-content-p'>{data.name}</p>
                    <span className='circle' style={{backgroundColor:getAlterColor("#191919","#FFF"),zIndex:1000}}>
                      {data.active ? <CheckCircle /> : <TimeQuery closed = {getClosedStatus()}/> }
                    </span>
                </div>
                <div className='timeline-item-time'>
                { (data.time != null && data.time != undefined && data.time != "NA" && data.time != "") &&<time style={{whiteSpace:'nowrap',color:getAlterColor("#DFDFDF","#000")}}>{getFormatedDate(data.time)}</time>}
                </div>
              </div>
            </div>
          )
        )}
      </div>

  
      <div className="timeline-container">

        {getEnv("REACT_APP_VDC_PLATFORM") !== "true" && props.otherTimeline?.length>0 &&(
          <>
        <hr style={{color:getAlterColor("#C1C1C1","rgb(75 75 75)")}}></hr>
        <p>{t("label.qc-timeline")}</p>
        {props.otherTimeline.map((data, idx) => (
            <div key={idx} className={getOtherTimelineActiveClassName(data,idx)}>
              <div className="timeline-item" style={{width:getEnv("REACT_APP_HYBRID_MODE") == "false" ? "48%":"44%"}}>
                {(data.username != null && data.username != "") &&<div style={{color:getAlterColor("#C1C1C1","rgb(75 75 75)"),top:"3.0em"}} className='time-difference-container'> 
                <span style={{color: getThemeColor("primary-color")}} className='time-difference-text'>
                {t("label.username")}:&nbsp;
                </span> {data.username}
                  </div>}

                {(data.diff != "NA" && data.diff != "") &&<div style={{color:getAlterColor("#C1C1C1","rgb(75 75 75)"),top:"4.5em"}} className='time-difference-container'> 
                <span style={{color: getThemeColor("primary-color")}} className='time-difference-text'>
                {t("label.elapse-time")}:&nbsp;
                </span> {formatMinutes(data.diff)}
                  </div>}

                <div style={{color: getThemeColor("primary-color")}} className="timeline-item-content">                    
                    <p className='timeline-item-content-p' style={{textTransform:"capitalize", wordBreak:"break-word", whiteSpace:"normal"}}>{getQcTimelineActionLabel(data.name)}</p>
                    <span className='circle' style={{backgroundColor:getAlterColor("#191919","#FFF"),zIndex:1000}}>
                      {<CheckCircle /> }
                    </span>
                </div>
                <div className='timeline-item-time'>
                { (data.time != null && data.time != undefined && data.time != "NA" && data.time != "") &&<time style={{whiteSpace:'nowrap',color:getAlterColor("#DFDFDF","#000")}}>{getFormatedDate(data.time)}</time>}
                </div>
              </div>
            </div>
          )
        )}
        </>
        )}
      </div>
    
    {showSeriesUploadHistory && 
          <ModalMain
            showModal={showSeriesUploadHistory}
            modalDetails={modalDetails}
          />}

</div>
  )};

export default TATTimelineBody